import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export interface WeatherInfo {
  temp: number;
  code: number;
}

export interface UseHomeResult {
  greeting: string;
  firstName: string;
  weather: WeatherInfo | null;
}

const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
};

const getFirstName = (name?: string, username?: string): string => {
  if (name) {
    const parts = name.split(' ');
    const first = parts[0]?.toLowerCase() === 'admin' && parts[1] ? parts[1] : parts[0];
    if (first) return first;
  }
  if (username) {
    const namePart = username.split('@')[0]?.split('.')[0];
    if (namePart) return namePart.charAt(0).toUpperCase() + namePart.slice(1);
  }
  return 'there';
};

/** Greeting + Stavanger weather for the home workbench. */
export const useHome = (): UseHomeResult => {
  const { user } = useAuth();
  const [weather, setWeather] = useState<WeatherInfo | null>(null);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const res = await fetch(
          'https://api.open-meteo.com/v1/forecast?latitude=58.97&longitude=5.73&current=temperature_2m,weather_code'
        );
        const data = await res.json();
        if (data.current?.temperature_2m !== undefined) {
          setWeather({
            temp: Math.round(data.current.temperature_2m),
            code: data.current.weather_code ?? 0,
          });
        }
      } catch {
        /* weather is non-critical */
      }
    };
    fetchWeather();
  }, []);

  return {
    greeting: getGreeting(),
    firstName: getFirstName(user?.name, user?.username),
    weather,
  };
};
